<template>
    <div>
        <DxDataGrid ref="dataGrid" :allowColumnReordering="true" :data-source="{
            store: dsOferte,
            filter: ['SaleID', '=', opportunityId]
        }" :allowColumnResizing="true" key-expr="ID" :columnAutoWidth="false" :columnResizingMode="'nextColumn'"
            :show-borders="true" :syncLookupFilterValues="false" :filter-sync-enabled="true" :show-row-lines="true"
            :show-column-lines="false" :allowMerging="'Cells'" height="100%" class="grid theme-dependent"
            @exporting="onExporting" @selection-changed="onSelectionChanged" @editing-start="onEditingStart">
            <DxSelection mode="single" />
            <DxScrolling :mode="'virtual'" />
            <DxColumnChooser :enabled="true" :allow-search="true" title="Selector coloane" />
            <DxPaging :page-size="20" />
            <DxSorting mode="multiple" />
            <DxHeaderFilter :visible="false" />
            <DxFilterRow :visible="true" />
            <DxLoadPanel :show-pane="false" />
            <DxSearchPanel :visible="true" placeholder="Cauta Oferta" :search-visible-columns-only="true" />

            <DxGridToolbar>
                <DxGridToolbarItem location="after" locate-in-menu="auto">
                    <div>
                        <dx-button icon="plus" type="success" @click="onAddClick"
                            :disabled="isLocked || !resolvedIsOfertareStatus"
                            :hint="!resolvedIsOfertareStatus ? 'Adăugarea ofertelor este permisă doar în starea Ofertare' : 'Adaugă Ofertă'" />
                    </div>
                </DxGridToolbarItem>
                <DxGridToolbarItem location="after" locate-in-menu="auto">
                    <div>
                        <DxButton icon="refresh" @click="onRefreshClick" hint="Reimprospateaza" />
                    </div>
                </DxGridToolbarItem>
                <DxGridToolbarItem location="after" locate-in-menu="auto">
                    <div>
                        <div class="separator"></div>
                    </div>
                </DxGridToolbarItem>
                <DxGridToolbarItem name="exportButton" hint="Exporta" />
                <DxGridToolbarItem location="after" locate-in-menu="auto">
                    <div>
                        <div class="separator"></div>
                    </div>
                </DxGridToolbarItem>
                <DxGridToolbarItem name="columnChooserButton" locate-in-menu="auto" hint="Alege Coloanele" />
                <DxGridToolbarItem name="searchPanel" locate-in-menu="auto" />
            </DxGridToolbar>
            <DxTexts group-continued-message="Continuat de pe pagina anterioara"
                group-continues-message="Continuat pe pagina urmatoare" />
            <DxEditing :allowUpdating="!isLocked" :allowDeleting="!isLocked" mode="popup" @click="onRowRemoving">
                <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="580" :height="590">
                    <DxToolbarItem :template="customTitleTemplate" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="before"
                        :options="reviseButtonOptions" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after"
                        :options="successButtonOptions" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
                </DxPopup>
                <DxFormGrid>
                    <DxFormItemGrid item-type="group" :col-span="2" :col-count="1">
                        <DxFormItem dataField="Nume" />
                        <DxFormItem dataField="Data" editor-type="dxDateBox" :editor-options="{
                            type: 'datetime',
                            displayFormat: 'dd/MM/yyyy HH:mm',
                            dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ',
                            useMaskBehavior: true
                        }" />
                        <DxFormItemGrid item-type="simple" :col-span="1">
                            <template #default>
                                <div class="edit-file-card">
                                    <div class="edit-file-title">Documente / Fișiere</div>

                                    <input type="file" ref="editOfertaFileInput" style="display:none"
                                        @change="onReplaceFileSelectedCustom" />
                                    <input type="file" multiple id="editOfertaInputHidden" style="display:none"
                                        @change="onEditFileSelectedCustom" />

                                    <div v-if="isEditFilesLoading" class="edit-file-muted">Se încarcă...</div>

                                    <div v-else-if="editOfertaFiles.length === 0" class="edit-file-muted">
                                        Nu există fișiere atașate.
                                    </div>

                                    <div v-else class="files-list">
                                        <div class="file-row" v-for="f in editOfertaFiles" :key="f.ID"
                                            :class="{ active: selectedEditFile?.ID === f.ID }"
                                            @click="selectFileForReplace(f)">
                                            <div class="file-name">{{ f.FileName }}</div>
                                            <div class="file-actions">
                                                <button type="button"
                                                    class="dx-button dx-button-mode-text dx-button-normal dx-widget"
                                                    title="Descarcă" @click.stop="onDownloadOfertaFile(f)">
                                                    <span class="dx-button-content">
                                                        <i class="dx-icon dx-icon-download"></i>
                                                    </span>
                                                </button>
                                                <button type="button"
                                                    class="dx-button dx-button-mode-text dx-button-danger dx-widget"
                                                    title="Șterge" :disabled="isLocked"
                                                    @click.stop="onDeleteOfertaFile(f)">
                                                    <span class="dx-button-content">
                                                        <i class="dx-icon dx-icon-trash"></i>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Replace -->
                                    <div v-if="editOfertaFiles.length > 0" class="replace-block">
                                        <div class="replace-hint">
                                            Se va înlocui: <b>{{ selectedEditFile?.FileName || '-' }}</b>
                                        </div>
                                        <div class="replace-row">
                                            <span v-if="editReplaceFile" class="replace-new">
                                                Nou: {{ editReplaceFile.name }}
                                            </span>
                                            <span v-else class="replace-none">(Niciun fișier nou selectat)</span>
                                            <button type="button"
                                                class="dx-button dx-button-mode-outlined dx-button-normal dx-widget"
                                                :disabled="isLocked" @click="triggerFileSelect">
                                                <span class="dx-button-content">
                                                    <i class="dx-icon dx-icon-upload"></i>
                                                    <span class="dx-button-text">Alege alt fișier</span>
                                                </span>
                                            </button>
                                        </div>
                                        <div class="replace-actions">
                                            <button type="button"
                                                class="dx-button dx-button-mode-outlined dx-button-success dx-widget"
                                                :disabled="!selectedEditFile?.ID || !editReplaceFile"
                                                @click="replaceCurrentFile">
                                                <span class="dx-button-content">
                                                    <span class="dx-button-text">Înlocuiește</span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>

                                    <!-- Add new files -->
                                    <div class="add-new-files-block"
                                        style="margin-top: 16px; border-top: 1px dashed #e2e8f0; padding-top: 12px;">
                                        <div class="edit-file-title" style="margin-bottom: 8px;">Adaugă fișiere noi
                                        </div>
                                        <div style="display:flex; justify-content:space-between; align-items:center;">
                                            <div class="selected-files-list" style="flex:1;">
                                                <div v-if="selectedFilesEdit && selectedFilesEdit.length > 0">
                                                    <div v-for="(file, index) in selectedFilesEdit" :key="index"
                                                        style="display:flex; align-items:center; gap:6px; font-size:13px; font-weight:600; color:#059669; margin-bottom:4px;">
                                                        <span>{{ file.name }}</span>
                                                        <span class="dx-icon-remove"
                                                            style="cursor:pointer; color:#ef4444;"
                                                            @click="removeEditFile(index)" title="Șterge fișier"></span>
                                                    </div>
                                                </div>
                                                <span v-else class="edit-file-muted" style="font-size:12px;">
                                                    (Niciun fișier nou selectat)
                                                </span>
                                            </div>
                                            <button type="button"
                                                class="dx-button dx-button-mode-outlined dx-button-normal dx-widget"
                                                :disabled="isLocked" @click="triggerEditFileAdd">
                                                <span class="dx-button-content">
                                                    <i class="dx-icon dx-icon-upload"></i>
                                                    <span class="dx-button-text">Alege fișiere</span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </DxFormItemGrid>
                    </DxFormItemGrid>
                </DxFormGrid>
            </DxEditing>

            <DxStateStoring :enabled="true" :filterValue="false" :savingTimeout="100"
                storage-key="gridCardOferteState" />
            <DxColumn data-field="Nume" caption="Nume Ofertă" />

            <DxColumn data-field="Data" caption="Data" />
            <DxColumn data-field="DataModificat" sort-order="desc" :visible="false" caption="Data Modificare" />

            <DxColumn type="buttons" :buttons="[
                {
                    hint: 'Fișiere',
                    icon: 'floppy',
                    onClick: onViewOfertaFiles
                },
                {
                    hint: 'Descarcă Raport',
                    icon: 'print',
                    onClick: onDownloadReport
                },
                {
                    hint: 'Produse',
                    icon: 'box',
                    onClick: onShowProducts
                },
                {
                    hint: 'Revizie (creează o versiune nouă)',
                    icon: 'copy',
                    onClick: onRevise,
                    visible: !isLocked
                },
                {
                    name: 'edit',
                    visible: !isLocked
                },
                {
                    name: 'delete',
                    visible: !isLocked
                }
            ]" />
        </DxDataGrid>

        <!-- Popup Fișiere Ofertă -->
        <DxPopupAdd v-model:visible="isOfertaFilesVisible" :drag-enabled="false" :hide-on-outside-click="true"
            :show-close-button="true" :width="650" :height="500">
            <template #title>
                <div class="popup-header popup-header--files">
                    <div class="popup-header-main">
                        <span class="popup-header-icon dx-icon-floppy"></span>
                        <div class="popup-header-texts">
                            <div class="popup-header-title">{{ selectedOfertaForFiles?.Nume || 'Ofertă' }}</div>
                            <div class="popup-header-subtitle">Documente și fișiere atașate</div>
                        </div>
                    </div>
                    <div class="popup-header-meta">
                        <span class="status-chip status-chip--active">
                            {{ formatDate(selectedOfertaForFiles?.Data) }}
                        </span>
                    </div>
                </div>
            </template>

            <DxScrollView width="100%" height="100%" class="details-scroll-view">
                <div class="details-container">
                    <div class="info-sections-grid">
                        <!-- Left: offer info -->
                        <div class="info-column">
                            <div class="info-section-card">
                                <div class="section-header">
                                    <span class="dx-icon-info section-icon"></span>
                                    <span>Detalii Ofertă</span>
                                </div>
                                <div class="info-list">
                                    <div class="info-item">
                                        <label>Nume</label>
                                        <div class="value highlight">{{ selectedOfertaForFiles?.Nume || '-' }}</div>
                                    </div>
                                    <div class="info-item">
                                        <label>Data</label>
                                        <div class="value">{{ formatDate(selectedOfertaForFiles?.Data) }}</div>
                                    </div>
                                    <div class="info-item">
                                        <label>Oportunitate</label>
                                        <div class="value">{{ selectedOfertaForFiles?.Sale?.Titlu || '-' }}</div>
                                    </div>
                                    <div class="info-item">
                                        <label>Creat de</label>
                                        <div class="value">{{ selectedOfertaForFiles?.UserCreat || '-' }}</div>
                                    </div>
                                    <div class="info-item">
                                        <label>Modificat de</label>
                                        <div class="value">{{ selectedOfertaForFiles?.UserModificat || '-' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Right: files -->
                        <div class="info-column">
                            <div class="info-section-card">
                                <div class="section-header">
                                    <span class="dx-icon-floppy section-icon"></span>
                                    <span>Documente / Fișiere</span>
                                </div>
                                <div class="info-list">
                                    <div v-if="isOfertaViewFilesLoading" class="info-item">
                                        <div class="value">Se încarcă fișierele...</div>
                                    </div>
                                    <div v-else-if="ofertaViewFiles.length === 0" class="info-item">
                                        <div class="value">Nu există fișiere atașate.</div>
                                    </div>
                                    <div v-else class="info-item">
                                        <label>Fișiere ({{ ofertaViewFiles.length }})</label>
                                        <div class="files-list" style="max-height: 280px; overflow-y: auto;">
                                            <div class="file-row" v-for="f in ofertaViewFiles" :key="f.ID">
                                                <div class="file-name">{{ f.FileName }}</div>
                                                <div class="file-actions">
                                                    <DxButton icon="download" styling-mode="text" hint="Descarcă"
                                                        @click="() => onDownloadOfertaFile(f)" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </DxScrollView>
        </DxPopupAdd>

        <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false"
            :showTitle="true" :width="580" :height="450">
            <template #title>
                <div class="popup-header">
                    <div class="popup-header-main">
                        <span class="popup-header-icon dx-icon-add"></span>
                        <div class="popup-header-texts">
                            <div class="popup-header-title">Adăugare ofertă</div>
                            <div class="popup-header-subtitle">
                                Completează informațiile în pașii de mai jos
                            </div>
                        </div>
                    </div>
                    <div class="popup-header-meta">
                        <span class="status-chip status-chip--draft">
                            Nouă
                        </span>
                    </div>
                </div>
            </template>
            <div ref="popupBody" class="popup-body-simple popup-body-modern">
                <div class="form-content form-content-modern">
                    <DxForm :formData="formData">
                        <DxFormItem dataField="Nume" :editor-options="{ width: '100%' }">
                            <DxRequiredRule message="Câmpul 'Nume' este obligatoriu" />
                        </DxFormItem>
                        <DxFormItem dataField="Data" editor-type="dxDateBox" :editor-options="{
                            type: 'datetime',
                            displayFormat: 'dd/MM/yyyy',
                            dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ',
                            useMaskBehavior: true
                        }" />
                    </DxForm>

                    <input type="file" multiple ref="addOfertaFileInput" style="display:none"
                        @change="onAddFileSelected" />

                    <div class="edit-file-card" style="margin-top: 16px;">
                        <div class="edit-file-title">Documente / Fișiere</div>
                        <div style="display:flex; justify-content:space-between; align-items:center; margin-top:8px;">
                            <div class="selected-files-list" style="flex:1;">
                                <div v-if="selectedFilesAdd && selectedFilesAdd.length > 0">
                                    <div v-for="(file, index) in selectedFilesAdd" :key="index"
                                        style="display:flex; align-items:center; gap:6px; font-size:13px; font-weight:600; color:#059669; margin-bottom:4px;">
                                        <span>{{ file.name }}</span>
                                        <span class="dx-icon-remove" style="cursor:pointer; color:#ef4444;"
                                            @click="removeAddFile(index)" title="Șterge fișier"></span>
                                    </div>
                                </div>
                                <span v-else class="edit-file-muted" style="font-size:12px;">
                                    (Niciun fișier selectat)
                                </span>
                            </div>
                            <button type="button" class="dx-button dx-button-mode-outlined dx-button-normal dx-widget"
                                :disabled="isLocked" @click="triggerAddFileSelect">
                                <span class="dx-button-content">
                                    <i class="dx-icon dx-icon-upload"></i>
                                    <span class="dx-button-text">Alege fișiere</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="form-footer  footer-modern">
                    <div class="footer-right">
                        <DxButton text="Salvează" type="success" width="120" height="32" styling-mode="outlined"
                            @click="onSaveAdd" :disabled="isLocked" />
                        <DxButton text="Închide" type="danger" width="120" height="32" styling-mode="outlined"
                            @click="onCancel" />
                    </div>
                </div>
            </div>
        </DxPopupAdd>

        <DxPopupAdd v-model:visible="isProductsDetailsVisible" :drag-enabled="false" :hide-on-outside-click="true"
            :show-close-button="true" :width="750" :height="450">
            <template #title>
                <div class="popup-header popup-header--products">
                    <div class="popup-header-main">
                        <span class="popup-header-icon dx-icon-product"></span>
                        <div class="popup-header-texts">
                            <div class="popup-header-title">{{ selectedProduct.Nume || 'Detalii Ofertă' }}</div>
                            <div class="popup-header-subtitle">Informații generale despre ofertă</div>
                        </div>
                    </div>
                    <div class="popup-header-meta">
                        <span class="status-chip status-chip--active">
                            Activă
                        </span>
                    </div>
                </div>
            </template>

            <DxScrollView width="100%" height="100%" class="details-scroll-view">
                <div class="details-container">
                    <div class="info-sections-grid">
                        <div class="info-column">
                            <div class="info-section-card">
                                <div class="section-header">
                                    <span class="dx-icon-info section-icon"></span>
                                    <span>Detalii Ofertă</span>
                                </div>
                                <div class="info-list">
                                    <div class="info-item">
                                        <label>Nume Ofertă</label>
                                        <div class="value highlight">{{ selectedProduct.Nume || '-' }}</div>
                                    </div>
                                    <div class="info-item">
                                        <label>Data Ofertă</label>
                                        <div class="value">{{ formatDate(selectedProduct.Data) }}</div>
                                    </div>
                                    <div class="info-item">
                                        <label>Oportunitate</label>
                                        <div class="value">{{ selectedProduct.Sale?.Titlu || '-' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="info-column">
                            <div class="info-section-card">
                                <div class="section-header">
                                    <span class="dx-icon-clock section-icon"></span>
                                    <span>Istoric</span>
                                </div>
                                <div class="info-list">
                                    <div class="info-item">
                                        <label>Creat de</label>
                                        <div class="value highlight">{{ selectedProduct.UserCreat || '-' }}</div>
                                    </div>
                                    <div class="info-item">
                                        <label>Data Creării</label>
                                        <div class="value">{{ formatDate(selectedProduct.DataCreat, true) }}</div>
                                    </div>
                                    <div class="info-item">
                                        <label>Modificat de</label>
                                        <div class="value highlight">{{ selectedProduct.UserModificat || '-' }}</div>
                                    </div>
                                    <div class="info-item">
                                        <label>Data Modificării</label>
                                        <div class="value">{{ formatDate(selectedProduct.DataModificat, true) }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </DxScrollView>
        </DxPopupAdd>

        <DxPopupAdd v-model:visible="isRevisePopupVisible" :closeOnOutsideClick="false" :showCloseButton="true"
            :showTitle="true" :width="500" :height="320">
            <template #title>
                <div class="popup-header popup-header--revise">
                    <div class="popup-header-main">
                        <span class="popup-header-icon dx-icon-copy"></span>
                        <div class="popup-header-texts">
                            <div class="popup-header-title">Salvează ca (Revizuire)</div>
                            <div class="popup-header-subtitle">Introduceți numele pentru noua versiune</div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="popup-body-simple">
                <div class="form-content">
                    <DxForm :formData="reviseFormData">
                        <DxFormItem dataField="Nume" :label="{ text: 'Nume ofertă nouă' }"
                            :editor-options="{ width: '100%', placeholder: 'Ex: Ofertă v2' }" />
                    </DxForm>
                </div>
                <div class="form-footer footer-modern mt-6">
                    <DxButton text="Salvează" type="success" width="120" height="32" styling-mode="outlined"
                        @click="onReviseConfirm" />
                    <DxButton text="Anulează" type="danger" width="120" height="32" styling-mode="outlined"
                        @click="onReviseCancel" />
                </div>
            </div>
        </DxPopupAdd>
    </div>
</template>

<script lang="ts">
import DxValidator, { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator'
import { locale, loadMessages } from 'devextreme/localization';
import DxDropDownButton, { DxDropDownButtonTypes } from 'devextreme-vue/drop-down-button';
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd from 'devextreme-vue/popup';
import { DxSimpleItem, DxLabel } from 'devextreme-vue/form';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxForm, DxItem as DxFormItem } from 'devextreme-vue/form';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { jsPDF } from 'jspdf';
import { exportDataGrid as exportDataGridPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridExcel } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import CrmSalesProducts from '@/services/Comercial/CrmSalesProducts';
import DataSource from "devextreme/data/data_source";
import DxDropDownBox from "devextreme-vue/drop-down-box";
import axios from 'axios';

import {
    DxItem as DxGridToolbarItem,
    DxLookup,
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar as DxGridToolbar,
    DxEditing,
    DxColumnChooser,
    DxGrouping,
    DxGroupPanel,
    DxTexts,
    DxExport,
    DxSearchPanel,
    DxMasterDetail,
    DxPopup,
    DxToolbarItem,
    DxForm as DxFormGrid,
    DxItem as DxFormItemGrid,
    DxScrolling,
    DxHeaderFilter
} from 'devextreme-vue/data-grid';
import CrmOferte from '@/services/Comercial/CrmOferte';

export default defineComponent({
    components: {
        DxGridToolbar,
        DxDataGrid,
        DxColumn,
        DxSorting,
        DxSelection,
        DxFilterRow,
        DxStateStoring,
        DxLoadPanel,
        DxPaging,
        DxButton,
        DxEditing,
        DxPopupAdd,
        DxForm,
        DxSimpleItem,
        DxLabel,
        DxScrollView,
        DxLookup,
        DxColumnChooser,
        DxGrouping,
        DxGroupPanel,
        DxTexts,
        DxExport,
        DxSearchPanel,
        DxMasterDetail,
        DxPopup,
        DxToolbarItem,
        DxFormGrid,
        DxGridToolbarItem,
        DxScrolling,
        DxHeaderFilter,
        DxDropDownButton,
        DxFormItem,
        DxDropDownBox,
        DxFormItemGrid,
        DxRequiredRule
    },
    props: {
        opportunityId: {
            type: String,
            required: true
        },
        opportunityData: {
            type: Object,
            default: null
        },
        isLocked: {
            type: Boolean,
            default: false
        },
        // Rezolvat de părinte (StatusID prin nomenclatorul de statusuri, cu fallback pe nume) —
        // mai robust decât verificarea locală pe Status.Nume. Dacă nu e furnizat (componenta
        // e folosită autonom), se cade pe verificarea locală de mai jos.
        isOfertareStatus: {
            type: Boolean,
            default: null
        }
    },

    data() {
        return {
            deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
            dsOferte: {} as ODataStore,
            dsClase: {} as DataSource,
            isModalVisible: false,
            isProductsDetailsVisible: false,
            selectedProduct: {} as any,
            dataGrid: ref<DxDataGrid | null>(null),
            dsSales: {} as DataSource,
            sOportunitate: null,
            oportunitateSelectat: [],
            isRevisePopupVisible: false,
            reviseFormData: {
                Nume: '',
                SourceID: ''
            },
            formData: {
                Nume: '',
                Data: null,
                SaleID: null,
                DataCreat: null,
                UserCreat: '',
                DataModificat: null,
                UserModificat: ''
            },
            // File management — edit popup
            editOfertaFiles: [] as any[],
            isEditFilesLoading: false,
            currentEditingOfertaId: null as string | null,
            selectedEditFile: null as any,
            editReplaceFile: null as File | null,
            selectedFilesEdit: [] as File[],
            selectedFilesAdd: [] as File[],
            // File management — view popup
            isOfertaFilesVisible: false,
            selectedOfertaForFiles: null as any,
            ofertaViewFiles: [] as any[],
            isOfertaViewFilesLoading: false,
        };
    },
    computed: {
        fallbackIsOfertareStatus(): boolean {
            const nume = (this.opportunityData?.Status?.Nume || this.opportunityData?.Status || '')
                .toString().trim().toLowerCase();
            return nume === 'ofertare';
        },
        resolvedIsOfertareStatus(): boolean {
            return this.isOfertareStatus !== null ? this.isOfertareStatus : this.fallbackIsOfertareStatus;
        },

        reviseButtonOptions(): any {
            return {
                type: 'default',
                stylingMode: 'outlined',
                text: 'Salvează ca',
                icon: 'copy',
                width: 170,
                height: 32,
                disabled: this.isLocked,
                onClick: () => {
                    this.onReviseFromPopup();
                },
            };
        },
        successButtonOptions(): any {
            return {
                type: 'success',
                stylingMode: 'outlined',
                text: 'Salvează',
                width: 120,
                height: 32,
                disabled: this.isLocked,
                onClick: () => {
                    this.SaveEdit();
                },
            };
        },
        dangerButtonOptions(): any {
            return {
                type: 'danger',
                stylingMode: 'outlined',
                text: 'Închide',
                width: 120,
                height: 32,
                onClick: () => {
                    this.onCancel();
                },
            };
        },
        customTitleTemplate() {
            return `
          <div class="popup-header" style="width: 590px; margin: -5px -20px 0 -20px; padding: 16px 24px; background: linear-gradient(90deg, #ff2c21, #ff6a4a); display: flex; align-items: center; gap: 16px;">
             <span class="dx-icon-edit" style="font-size: 24px;  width: 40px; height: 20px; display: flex; align-items: center; justify-content: center; border-radius: 8px; color: white;"></span>
             <div style="display: flex; flex-direction: column; color: white;">
                <span style="font-size: 16px; font-weight: 700;">Editare Ofertă existentă</span>
                `;
        },
    },
    watch: {
        sOportunitate(newId) {
            if (newId) {
                this.dsSales.store().byKey(newId).then(x => {
                    if (!x) return;
                    x.Titlu = (x.Titlu ?? '(fara nume)');
                    this.oportunitateSelectat = [x];
                });

            } else {
                this.oportunitateSelectat = [];
            }
        },

    },
    methods: {

        // ─── File management ────────────────────────────────────────────────

        async onViewOfertaFiles(e: any) {
            const rowData = e?.row?.data;
            if (!rowData?.ID) return;
            this.selectedOfertaForFiles = rowData;
            this.isOfertaFilesVisible = true;
            await this.$nextTick();
            await this.loadOfertaViewFiles(rowData.ID);
        },

        async loadOfertaViewFiles(ofertaId: string) {
            this.isOfertaViewFilesLoading = true;
            try {
                const res = await CrmOferte.listFiles(ofertaId);
                const data = res?.data;
                this.ofertaViewFiles = Array.isArray(data) ? data : [];
            } catch (err) {
                console.error("Load oferta view files error:", err);
                this.ofertaViewFiles = [];
            } finally {
                this.isOfertaViewFilesLoading = false;
            }
        },

        async onEditingStart(e: any) {
            const ofertaId = e?.data?.ID;
            if (!ofertaId) return;
            this.currentEditingOfertaId = ofertaId;
            this.editReplaceFile = null;
            this.selectedFilesEdit = [];
            this.selectedEditFile = null;
            await this.loadEditFiles(ofertaId);
        },

        async loadEditFiles(ofertaId: string) {
            this.isEditFilesLoading = true;
            try {
                const res = await CrmOferte.listFiles(ofertaId);
                const data = res?.data;
                this.editOfertaFiles = Array.isArray(data) ? data : [];
                this.selectedEditFile = this.editOfertaFiles[0] || null;
            } catch (err) {
                console.error("Load oferta files error:", err);
                this.editOfertaFiles = [];
            } finally {
                this.isEditFilesLoading = false;
            }
        },

        selectFileForReplace(f: any) {
            this.selectedEditFile = f;
            this.editReplaceFile = null;
        },

        triggerFileSelect() {
            (this.$refs.editOfertaFileInput as HTMLInputElement)?.click();
        },

        onReplaceFileSelectedCustom(e: any) {
            const file = e?.target?.files?.[0] || null;
            this.editReplaceFile = file;
            e.target.value = "";
        },

        async replaceCurrentFile() {
            if (!this.selectedEditFile?.ID || !this.editReplaceFile) return;
            try {
                await CrmOferte.replaceFile(this.selectedEditFile.ID, this.editReplaceFile);
                notify("Fișier înlocuit.", "success", 1500);
                if (this.currentEditingOfertaId) {
                    await this.loadEditFiles(this.currentEditingOfertaId);
                    this.selectedEditFile =
                        this.editOfertaFiles.find(x => x.ID === this.selectedEditFile?.ID) ||
                        this.editOfertaFiles[0] || null;
                }
                this.editReplaceFile = null;
            } catch (err) {
                console.error(err);
                notify("Eroare la înlocuire fișier.", "error", 1500);
            }
        },

        triggerEditFileAdd() {
            const el = document.getElementById("editOfertaInputHidden") as HTMLInputElement;
            el?.click();
        },

        onEditFileSelectedCustom(e: any) {
            const files: File[] = Array.from(e?.target?.files || []);
            this.selectedFilesEdit = [...this.selectedFilesEdit, ...files];
            e.target.value = "";
        },

        removeEditFile(index: number) {
            this.selectedFilesEdit.splice(index, 1);
        },

        async onDownloadOfertaFile(file: any) {
            try {
                const res = await CrmOferte.downloadFile(file.ID);
                const fileName = file.FileName || "fisier";
                const blob = new Blob([res.data], { type: file.ContentType || "application/octet-stream" });
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            } catch (err) {
                console.error("Download error:", err);
                notify("Eroare la descărcare fișier.", "error", 1500);
            }
        },

        async onDeleteOfertaFile(file: any) {
            if (!file?.ID) return;
            try {
                await CrmOferte.deleteFile(file.ID);
                notify("Fișier șters.", "success", 1000);
                if (this.currentEditingOfertaId) {
                    await this.loadEditFiles(this.currentEditingOfertaId);
                }
            } catch (err) {
                console.error(err);
                notify("Eroare la ștergere fișier.", "error", 1500);
            }
        },

        triggerAddFileSelect() {
            (this.$refs.addOfertaFileInput as HTMLInputElement)?.click();
        },

        onAddFileSelected(e: any) {
            const files: File[] = Array.from(e?.target?.files || []);
            this.selectedFilesAdd = [...this.selectedFilesAdd, ...files];
            e.target.value = "";
        },

        removeAddFile(index: number) {
            this.selectedFilesAdd.splice(index, 1);
        },

        // ────────────────────────────────────────────────────────────────────

        setDeleteConfirmationMessage() {
            const dataGrid = this.$refs.dataGrid?.instance;
            dataGrid.option('editing', {
                allowDeleting: true,
                mode: 'popup',
                texts: {
                    confirmDeleteMessage: this.deleteConfirmationMessage,
                    confirmDeleteTitle: "Confirmare Ștergere",
                }
            });
        },
        createODataContext() {

            this.dsOferte = new ODataStore({
                url: AppSetting.API_Url_ComercialOdata + 'CRM_Oferte',
                key: 'ID',
                keyType: "Guid",
                fieldTypes: {
                    SaleID: 'Guid',
                },
                version: 4,
                beforeSend: (e) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                    };
                    e.params.$expand = "Sale($select=Titlu)";

                }
            });
            this.dsSales = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_Sales',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Titlu',
                ],

            });
        },

        toNullIfEmpty(val) {
            return val === '' || val === undefined || val === null ? null : val;
        },
        normalizeFormData(formData) {
            const cleaned = { ...formData };
            const dateFields = [
                'Data',
                'DataCreat',
            ];

            dateFields.forEach((field) => {
                const val = cleaned[field];
                cleaned[field] = this.toNullIfEmpty(val) !== null ? new Date(val) : null;
            });

            Object.keys(cleaned).forEach((key) => {
                cleaned[key] = this.toNullIfEmpty(cleaned[key]);
            });

            return cleaned;
        },

        onSaveAdd() {

            if (!this.formData.Nume || this.formData.Nume.trim() === '') {
                notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
                return;
            }

            const cleanedFormData = this.normalizeFormData(this.formData);

            // ADAUGĂ 'Nume' în această listă!
            const backendFields = [
                'Nume', 'SaleID', 'DataCreat', 'UserCreat', 'Data'
            ];

            const payload = Object.fromEntries(
                Object.entries(cleanedFormData).filter(([key]) =>
                    backendFields.includes(key)
                )
            );

            // Asigură-te că SaleID primește valoarea corectă
            payload.SaleID = this.toNullIfEmpty(this.sOportunitate);
            CrmOferte.save(payload)
                .then(async (response: any) => {
                    const newOffer = response.data;

                    if (newOffer?.ID && this.selectedFilesAdd.length > 0) {
                        for (const file of this.selectedFilesAdd) {
                            try {
                                await CrmOferte.uploadFile(newOffer.ID, file);
                            } catch (err) {
                                console.error(`Eroare upload fișier ${file.name}:`, err);
                                notify(`Eroare la încărcarea fișierului ${file.name}`, 'error', 2000);
                            }
                        }
                    }

                    this.isModalVisible = false;
                    notify('Datele au fost salvate cu succes!', 'success', 1000);

                    this.formData = {
                        Nume: '',
                        Data: null,
                        DataCreat: null,
                        UserCreat: '',
                        DataModificat: null,
                        UserModificat: ''
                    };
                    this.sOportunitate = null;
                    this.selectedFilesAdd = [];
                    this.createODataContext();

                    if (newOffer && newOffer.ID) {
                        this.$emit('show-products', newOffer, true);
                    }
                })
                .catch((error) => {
                    notify('Eroare la salvare!', 'error', 1500);
                });
        },

        async onDownloadReport(e) {
            const rowData = e?.row?.data;
            if (!rowData?.ID) return;

            const saleId = rowData.SaleID || this.opportunityId;
            const offerId = rowData.ID;

            const payload = [
                {
                    "Name": "SaleID",
                    "Value": saleId,
                    "Type": "Guid"
                },
                {
                    "Name": "OfferID",
                    "Value": offerId,
                    "Type": "Guid"
                }
            ];

            const reportID = "BB8AE837-FB4D-4966-B274-25308742A96D";
            const reportDesignID = "E022606F-B427-45AE-9661-EF94A6E6B2F5";
            const reportUrl = `https://mdapp01:1000/ERA_Rapoarte/api/Report/GetReport?reportID=${reportID}&reportDesignID=${reportDesignID}`;

            try {
                notify('Generare raport...', 'info', 1000);
                const response = await axios.post(reportUrl, payload, {
                    responseType: 'blob',
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('ERA_Jwt')
                    }
                });

                const fileName = `Oferta_${rowData.Nume || 'Generata'}.pdf`;
                saveAs(response.data, fileName);
                notify('Raport generat cu succes!', 'success', 1000);
            } catch (error) {
                console.error('Error generating report:', error);
                notify('Eroare la generarea raportului!', 'error', 2000);
            }
        },

        onViewDetails(e) {
            const rowData = e?.row?.data;
            if (rowData) {
                this.showProductsDetails(rowData);
            }
        },
        onShowProducts(e) {
            const rowData = e?.row?.data;
            if (rowData) {
                this.$emit('show-products', rowData, true);
            }
        },

        onRevise(e) {
            const rowData = e.row.data;
            if (!rowData?.ID) return;

            const currentName = rowData.Nume || "";
            const baseName = currentName.replace(/\sv\d+$/, "");

            // To find the next version, we'd ideally scan all rows, 
            // but for a single row action, we can just suggest v+1 of THIS row or let user edit.
            // Using the logic from onReviseFromPopup but adapted for a specific row:
            const visibleRows = this.$refs.dataGrid.instance.getVisibleRows();
            let maxVersion = 0;
            visibleRows.forEach(row => {
                const name = row.data.Nume || "";
                if (name.startsWith(baseName)) {
                    const match = name.match(/\sv(\d+)$/);
                    if (match) {
                        const v = parseInt(match[1]);
                        if (v > maxVersion) maxVersion = v;
                    }
                }
            });

            const nextVersion = maxVersion + 1;
            this.reviseFormData = {
                Nume: `${baseName} v${nextVersion}`,
                SourceID: rowData.ID
            };
            this.isRevisePopupVisible = true;
        },
        onReviseFromPopup() {
            const dataGrid = this.$refs.dataGrid?.instance;
            if (!dataGrid) return;

            const visibleRows = dataGrid.getVisibleRows();
            const editingRow = visibleRows.find(row => row.isEditing);
            const rowData = editingRow?.data;

            if (!rowData?.ID) {
                notify('Nu s-au putut prelua datele pentru revizie!', 'warning', 1500);
                return;
            }

            const currentName = rowData.Nume || "";
            const baseName = currentName.replace(/\sv\d+$/, "");

            let maxVersion = 0;
            visibleRows.forEach(row => {
                const name = row.data.Nume || "";
                if (name.startsWith(baseName)) {
                    const match = name.match(/\sv(\d+)$/);
                    if (match) {
                        const v = parseInt(match[1]);
                        if (v > maxVersion) maxVersion = v;
                    }
                }
            });

            const nextVersion = maxVersion + 1;
            this.reviseFormData = {
                Nume: `${baseName} v${nextVersion}`,
                SourceID: rowData.ID
            };
            this.isRevisePopupVisible = true;
        },

        async onReviseConfirm() {
            if (!this.reviseFormData.Nume) {
                notify('Vă rugăm să introduceți un nume!', 'warning', 1000);
                return;
            }

            try {
                notify('Creare revizie nouă...', 'info', 1000);
                const response = await CrmOferte.revise(this.reviseFormData.SourceID, { Nume: this.reviseFormData.Nume });

                // Get the new Offer ID from response. OData actions return the result in response.data
                const newOffer = response.data;
                const newOfferID = newOffer?.ID;

                if (newOfferID && this.reviseFormData.SourceID) {
                    notify('Copiere produse...', 'info', 1000);
                    // Fetch products from the source offer
                    const productsUrl = `${AppSetting.API_Url_ComercialOdata}CRM_SalesProducts?$filter=OfertaID eq ${this.reviseFormData.SourceID}`;
                    const productsResponse = await axios.get(productsUrl, {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('ERA_Jwt')
                        }
                    });

                    const productsToCopy = productsResponse.data?.value || [];

                    if (productsToCopy.length > 0) {
                        const copyPromises = productsToCopy.map((prod: any) => {
                            // Destructure to remove administrative/navigation fields
                            const {
                                ID,
                                DataCreare, DataModificare,
                                UserCreare, UserModificare,
                                Sale, Produs, PretListaValuta, Clasa, Categorie, Furnizor,
                                ...cleanProd
                            } = prod;

                            return CrmSalesProducts.save({
                                ...cleanProd,
                                OfertaID: newOfferID
                            });
                        });

                        await Promise.all(copyPromises);
                    }
                }

                notify('Ofertă nouă creată cu succes!', 'success', 1000);
                this.isRevisePopupVisible = false;

                const dataGrid = this.$refs.dataGrid?.instance;
                if (dataGrid) {
                    dataGrid.cancelEditData();
                }
                this.createODataContext();
            } catch (error) {
                console.error('Error during offer revision:', error);
                notify('Eroare la crearea reviziei!', 'error', 1500);
            }
        },

        onReviseCancel() {
            this.isRevisePopupVisible = false;
        },
        showProductsDetails(product: any) {
            this.selectedProduct = { ...product };
            this.isProductsDetailsVisible = true;
        },

        onAddClick() {
            if (this.isLocked || !this.resolvedIsOfertareStatus) return;
            this.formData.Data = new Date();
            this.sOportunitate = this.opportunityId;
            this.isModalVisible = true;
        },
        onRefreshClick() {
            this.createODataContext();
            notify('Datele au fost actualizate cu succes!', 'success', 1000);
        },
        async SaveEdit() {
            try {
                await this.$refs.dataGrid?.instance?.saveEditData();
                notify('Datele au fost salvate cu succes!', 'success', 1000);

                if (this.editReplaceFile && this.selectedEditFile?.ID) {
                    await CrmOferte.replaceFile(this.selectedEditFile.ID, this.editReplaceFile);
                    this.editReplaceFile = null;
                    if (this.currentEditingOfertaId) {
                        await this.loadEditFiles(this.currentEditingOfertaId);
                    }
                    notify('Fișier actualizat.', 'success', 1500);
                }

                if (this.selectedFilesEdit.length > 0 && this.currentEditingOfertaId) {
                    for (const file of this.selectedFilesEdit) {
                        try {
                            await CrmOferte.uploadFile(this.currentEditingOfertaId, file);
                        } catch (err) {
                            console.error(`Eroare upload fișier ${file.name}:`, err);
                            notify(`Eroare la încărcarea fișierului ${file.name}`, 'error', 2000);
                        }
                    }
                    await this.loadEditFiles(this.currentEditingOfertaId);
                    this.selectedFilesEdit = [];
                    notify('Fișiere noi adăugate.', 'success', 1500);
                }
            } catch (error) {
                console.error(error);
                notify('Eroare la salvarea datelor!', 'error', 1000);
            }
        },
        onCancel() {
            this.isModalVisible = false;
            this.selectedFilesAdd = [];
            this.$refs.dataGrid?.instance?.cancelEditData();
        },
        onRowRemoving() {
            notify('Datele au fost șterse cu succes!', 'success', 1000);
        },

        onExporting(e: any) {
            if (e.format === 'pdf') {
                const doc = new jsPDF();
                exportDataGridPdf({
                    jsPDFDocument: doc,
                    component: e.component,
                    indent: 5,
                }).then(() => {
                    doc.save('Oferte.pdf');
                });
            } else if (e.format === 'xlsx') {

                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('oferte');

                exportDataGridExcel({
                    component: e.component,
                    worksheet,
                    autoFilterEnabled: true,
                }).then(() => {
                    workbook.xlsx.writeBuffer().then((buffer: any) => {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Oferte.xlsx');
                    });
                });
                e.cancel = true;
            }
        },

        formatDate(date: any, showTime = false) {
            if (!date) return '-';
            const d = new Date(date);
            if (isNaN(d.getTime())) return '-';

            const options: Intl.DateTimeFormatOptions = {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            };

            if (showTime) {
                options.hour = '2-digit';
                options.minute = '2-digit';
            }

            return d.toLocaleDateString('ro-RO', options);
        },

        onSelectionChanged(e: any) {
            if (this.isFirstLoad) return;
            const selectedRow = e.selectedRowsData[0];
            if (selectedRow) {
                this.$emit('offer-selected', selectedRow);
            } else {
                this.$emit('offer-selected', null);
            }
        },
    },

    mounted() {
        this.createODataContext();
        this.setDeleteConfirmationMessage();
        this.$refs.dataGrid?.instance?.clearSelection();

        // Suppress first selection event from stored state
        setTimeout(() => {
            this.isFirstLoad = false;
        }, 1000);

        loadMessages({
            "ro": {
                "Yes": "Da",
                "No": "Nu",
            }
        });

        locale('ro');
    },
});
</script>
<style scoped lang="scss">
// File management styles
.edit-file-card {
    width: 100%;
    box-sizing: border-box;
}

.edit-file-title {
    font-weight: 700;
    margin-bottom: 8px;
    color: #334155;
    font-size: 13px;
}

.edit-file-muted {
    color: #64748b;
    font-size: 13px;
}

.files-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    max-height: 130px;
    overflow-y: auto;
}

.file-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 10px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    cursor: pointer;

    &.active {
        border-color: #ff2c21;
        background: rgba(255, 44, 33, 0.06);
    }
}

.file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 380px;
    font-size: 13px;
}

.file-actions {
    display: flex;
    gap: 4px;
    flex-shrink: 0;
}

.replace-block {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.replace-hint {
    font-size: 12px;
    color: #64748b;
}

.replace-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}

.replace-new {
    font-size: 13px;
    font-weight: 600;
    color: #059669;
}

.replace-none {
    font-size: 12px;
    color: #94a3b8;
}

.replace-actions {
    display: flex;
    justify-content: flex-end;
}

.details-scroll-view {
    background-color: #f8f9fc;
}

.details-container {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

/* Header Context */
.popup-header--products,
.popup-header--revise,
.popup-header--files {
    background: linear-gradient(90deg, #ff2c21, #ff6a4a);
}

/* Info sections grid for files popup */
.info-sections-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

.info-column {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.info-section-card {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.section-header {
    padding: 14px 16px;
    background: #fcfcfd;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 700;
    color: #334155;
    font-size: 14px;
}

.section-icon {
    color: #64748b;
    font-size: 18px;
}

.info-list {
    padding: 10px 0;
}

.info-item {
    padding: 10px 16px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    label {
        font-size: 11px;
        color: #94a3b8;
        text-transform: uppercase;
        font-weight: 600;
    }

    .value {
        font-size: 14px;
        color: #334155;
        font-weight: 500;

        &.highlight { color: #2563eb; }
        &.success { color: #059669; }
    }
}

/* Stats Row */
.stats-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
}

.stat-card {
    background: white;
    padding: 16px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
    transition: transform 0.2s, box-shadow 0.2s;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    }
}

.stat-icon {
    font-size: 24px;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #f1f5f9;
    color: #475569;
}

.stat-card--quantity .stat-icon {
    background: #eff6ff;
    color: #2563eb;
}

.stat-card--price .stat-icon {
    background: #fdf2f8;
    color: #db2777;
}

.stat-card--total .stat-icon {
    background: #ecfdf5;
    color: #059669;
}

.stat-content {
    flex: 1;
}

.stat-label {
    font-size: 11px;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    font-weight: 600;
}

.stat-value {
    font-size: 17px;
    font-weight: 700;
    color: #1e293b;
    margin-top: 2px;
}

/* Info Sections */
.info-sections-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

.info-column {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.info-section-card {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.section-header {
    padding: 14px 16px;
    background: #fcfcfd;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 700;
    color: #334155;
    font-size: 14px;
}

.section-icon {
    color: #64748b;
    font-size: 18px;
}

.info-list {
    padding: 10px 0;
}

.info-item {
    padding: 10px 16px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    label {
        font-size: 11px;
        color: #94a3b8;
        text-transform: uppercase;
        font-weight: 600;
    }

    .value {
        font-size: 14px;
        color: #334155;
        font-weight: 500;

        &.multiline {
            line-height: 1.5;
            font-style: italic;
            color: #475569;
        }

        &.highlight {
            color: #2563eb;
        }

        &.success {
            color: #059669;
        }
    }
}

/* Status Chips */
.status-chip {
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.3);

    &--active {
        background: #ecfdf5;
        color: #065f46;
        border-color: #6ee7b7;
    }
}

/* Metadata */
.system-meta-card {
    background: #f1f5f9;
    border-radius: 10px;
    padding: 12px 20px;
}

.meta-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
}

.meta-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #64748b;
}

.meta-icon {
    font-size: 14px;
}

.meta-separator {
    width: 1px;
    height: 14px;
    background: #cbd5e1;
}

/* Base popup styles restored */
.popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 18px;
    background: linear-gradient(90deg, #ff2c21, #ff6a4a);
    color: #fff;
}

.popup-header-main {
    display: flex;
    align-items: center;
    gap: 10px;
}

.popup-header-icon {
    font-size: 20px;
}

.popup-header-texts {
    display: flex;
    flex-direction: column;
}

.popup-header-title {
    font-size: 15px;
    font-weight: 700;
}

.popup-header-subtitle {
    font-size: 12px;
    opacity: 0.85;
}

.popup-header-meta {
    display: flex;
    align-items: center;
}

.popup-body-simple {
    padding: 20px;
}

.popup-body-modern {
    padding: 14px 18px 56px 18px;

}

/* Adaugă în secțiunea <style> a componentei tale */
.form-footer.footer-modern {
    margin-top: 30px;
    /* Ajustează valoarea după bunul plac */
    padding-top: 15px;
    border-top: 1px solid #eee;
    /* Opțional: o linie subtilă de separare */
}

.form-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

.footer-fixed {
    position: sticky;
    bottom: 0;
    padding: 10px 16px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    z-index: 10;
}

.footer-right .dx-button {
    margin-left: 8px;
}
</style>